import { render, staticRenderFns } from "./COAppConfigsList.vue?vue&type=template&id=211b31dc"
import script from "./COAppConfigsList.vue?vue&type=script&lang=js"
export * from "./COAppConfigsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211b31dc')) {
      api.createRecord('211b31dc', component.options)
    } else {
      api.reload('211b31dc', component.options)
    }
    module.hot.accept("./COAppConfigsList.vue?vue&type=template&id=211b31dc", function () {
      api.rerender('211b31dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/COAppConfigsList.vue"
export default component.exports